import BaseApi from "./BaseApi";
const baseUrl = 'api/Report';

interface GeneralSearchResult {
    clients?: SearchResult;
    leads: SearchResult;
    proposals?: SearchResult;
    user?: SearchResult;
}

interface SearchResult {
    list: any[];
    total: number;
}

class ReportService {
    static getGeneralSearch(filter: object): Promise<GeneralSearchResult> {
        return BaseApi.get(`${baseUrl}/GeneralSearch`, { params: filter });
    }

    static getGeneralSearch_Clients(filter: object): Promise<SearchResult> {
        return BaseApi.get(`${baseUrl}/GeneralSearch/Clients`, { params: filter });
    }

    static getGeneralSearch_Leads(filter: object): Promise<SearchResult> {
        return BaseApi.get(`${baseUrl}/GeneralSearch/Leads`, { params: filter });
    }

    static getGeneralSearch_Proposals(filter: object): Promise<SearchResult> {
        return BaseApi.get(`${baseUrl}/GeneralSearch/Proposals`, { params: filter });
    }

    static getGeneralSearch_Users(filter: object): Promise<SearchResult> {
        return BaseApi.get(`${baseUrl}/GeneralSearch/Users`, { params: filter });
    }
}

export default ReportService;